import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { Table } from "react-bootstrap";
import withRouter from "../../../util/WithRouter";
import Constants from "../../../util/Constants";
import ApiUiController from "../../../controller/ApiUiController";
import IndividualSalesReportAPI from "../../../api/IndividualSalesReportAPI";
import ChartComponent from "../FixedReportChart";

class IndividualLeadStatus extends React.Component {
  constructor(props) {
    super(props);

    // Load progress options from local storage
    const progressOptions = reactLocalStorage.getObject(Constants.Model).lead.fields.progress.options;

    this.state = {
      progressData: [], // Data received from the API
      progressOptions,  // Predefined progress options
    };
  }

  componentDidMount() {
    // Fetch data from the API
    IndividualSalesReportAPI.getIndividualLeadsStatus(
      this.props.filters,
      this.handleReceivedData,
      this.handleFail
    );
  }

  handleReceivedData = (data) => {
    // Filter out items where progress is 0
    const filteredData = data.filter(item => item.progress !== 0);
    this.setState({ progressData: filteredData });
  };

  handleFail = () => {
    console.error("Failed to fetch data");
  };

  render() {
    const { progressData, progressOptions } = this.state;

    // Create a record of sums for each progress option, starting at 0
    const progressSums = {};
    progressOptions.forEach(option => {
      progressSums[option.value] = 0;
    });

    // Fill in the actual values from the API data
    progressData.forEach(item => {
      if (progressSums.hasOwnProperty(item.progress)) {
        progressSums[item.progress] = item.sum;
      }
    });

    // Calculate the total sum of all progress values
    const totalSum = Object.values(progressSums).filter(Boolean).reduce((total, value) => total + value, 0);

    return (
      <ApiUiController inApiCall={false}>
      <div>
        <h2>Lead Status Report</h2>
        <hr />
         <div className="row mt-3 p-2">
        <Table striped bordered hover className="col-md-6">
          <thead>
            <tr>
              <th>Status</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {/* Render progress status and corresponding sums */}
            {progressOptions.map((option, index) => (
              <tr key={index}>
                <td>{option.label}</td>
                <td>{progressSums[option.value]}</td>
              </tr>
            ))}
            {/* Display the total sum */}
            <tr>
              <td><strong>Total</strong></td>
              <td><strong>{totalSum}</strong></td>
            </tr>
          </tbody>
        </Table>
        <div className="col-md-6">
          {/* Pass progressSums and progressOptions to ChartComponent */}
          <ChartComponent progressSums={progressSums} progressOptions={progressOptions} type={"line"} />
        </div>
       </div>
      </div>
    </ApiUiController>
    );
  }
}

export default withRouter(IndividualLeadStatus);
